export default __webpack_public_path__ + "static/media/order_managemnt_orange.a324e5a9.svg";